import EmailStatsApi from '@/api/EmailStats/api'

export default {
  methods: {
    updateEmailStatus ({messageId, status}) {
      const timeOfReplyMessage = new Date()
      EmailStatsApi.updateEmailStatus({messageId, status, timeOfReplyMessage})
        .then(({data}) => {
          const delayedJobId = data.delayedJobId
          if (delayedJobId) this.removeJobNotification({delayedJobId})
        })
        .catch(err => {
          console.error(err)
        })
    },
    removeJobNotification ({delayedJobId}) {
      EmailStatsApi.removeJobNotification({delayedJobId})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/updateEmailStatus.js